import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const ungroupAnalyzerAndSwitch = ({
  data,
}: {
  data: { analyzerId: number; switchId: number };
}) => {
  const { analyzerId, switchId } = data;
  return axios.delete(`/api/analyzers/${analyzerId}/switch/${switchId}`);
};

type UseUngroupAnalyzerAndSwitchOptions = {
  config?: MutationConfig<typeof ungroupAnalyzerAndSwitch>;
  analyzerId: number;
};

export const useUngroupAnalyzerAndSwitch = ({
  config,
  analyzerId,
}: UseUngroupAnalyzerAndSwitchOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['switches']);
      queryClient.invalidateQueries(['analyzers']);
      queryClient.refetchQueries(['analyzer', analyzerId]);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: ungroupAnalyzerAndSwitch,
  });
};
